<template>
  <div class="molecular-modal">
    <button class="molecular-modal-btn" @click="modal = !modal">See Molecular Scale</button>
    <!-- TODO: Get Microscope Icon -->

    <transition name="modal" mode="out-in">
      <div class="modal-background" @click.self="modal = false" v-if="modal">
        <div class="modal-body">

          <p>For the sake of simplicity, anions and water molecules are not shown in this animation.</p>

          <div class="spheres">
            <template v-for="i in 8">
              <template v-for="j in 2">
                <div class="bigsphere Cu" :style="`top:${i}em;left:${j}em`">
                  <span>Cu</span>
                </div>
              </template>
            </template>

            <div class="smallsphere" style="top:1em;right:0em;"><span>H</span></div>
            <div class="smallsphere second" style="top:3em;right:0.1em;"><span>H</span></div>

          </div>

          <button class="modal-close btn" @click="modal=false">Dismiss</button>
        </div>
      </div>
    </transition>
  </div>
</template>


<script>
export default {
  name:"MolecularModalAcidCopper",
  props:{
    metal: String
  },
  data() {
    return {
      modal: false
    }
  }
}
</script>


<style lang="scss" scoped>
  .spheres {
    width: 10em;
    height: 10em;
    overflow: hidden;
    font-size: 3em;
    position: relative;
  }
  .bigsphere, .smallsphere {
    position: absolute;
    border-radius: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    span { font-size: 0.3em; color: #000; } 
  }
  .bigsphere {
    width: 1em;
    height: 1em;
    background: #ccc;
  }
  .smallsphere {
    width: 0.5em;
    height: 0.5em;
    border-radius: 100%;
    background: #ccf;
    span { font-size: 0.2em; color: #000; } 
    &:after {
      position: absolute;
      top: -0.5em;
      right: -0.3em;
      content: '+';
      font-size: 0.3em;
      color: #008;
    }
    animation: moveSmallBalls linear 8s;
    animation-iteration-count: infinite; //1;
    transform-origin: 50% 50%;
    animation-fill-mode: forwards;
    animation-timing-function: linear;
    &.second {
      animation: moveSmallBallSecond linear 8s;
      animation-iteration-count: infinite; //1;
      transform-origin: 50% 100%;
      animation-fill-mode: forwards;
      animation-timing-function: linear;      
    }
  }

  .Cu{
    background: linear-gradient(to right, darken(#C48226, 20%), #C48226, lighten(#C48226, 15%));
    color: #fff;
  }

  @keyframes moveSmallBalls{
    0% { transform: translate(0,1em) rotate(0deg); }
    30% { transform: translate(-6.5em,2.7em) rotate(20deg); }
    60%{ transform: translate(1em,2em) rotate(120deg); }
    100% { transform: translate(1em,2em) rotate(120deg); }
  }
  @keyframes moveSmallBallSecond{
    0% { transform: translate(0,0) rotate(0deg); }
    30% { transform: translate(-6.3em,1.2em) rotate(-10deg); }
    60%{ transform: translate(1em,2em) rotate(120deg); }
    100% { transform: translate(1em,2em) rotate(120deg); }
  }

  .molecular-modal{

    .molecular-modal-btn{
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      border:1px solid $bordergrey;
      color: $grey;
      background: #fff;
      padding: .3em 1.4em;
      border-radius: 3em;
      font-size: .7rem;
      font-weight: 400;
      white-space: nowrap;
      transition: all 250ms;

      &:hover{
        border-color: $blue;
        background: $blue;
        color: #fff;
      }

      @media screen and (min-width: 480px) {
        font-size: 1em;
      }
    }
  }

  .modal-background{
    background: rgba($green, 0.9);
    @supports(backdrop-filter: blur(10px)){
      background: rgba($green, 0.3);
      backdrop-filter: blur(10px);
    }
    position: fixed;
    top: 0px;
    left: 0%;
    width: 100%;
    height: 100%;
    z-index: 1000;
    padding: 1em;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow-y: scroll;


    .modal-body{
      background: #fff;
      padding: 2em;
      border-radius: 1em;
      width: 90%;
      max-width: 680px;
      text-align: center;
      p { font-size: 0.7em; color: #aaa; }
    }
  }

  .modal-enter-active, .modal-leave-active {
    transition: all 500ms;

    .modal-body{
      transition: all 500ms;
    }
  }
  .modal-enter, .modal-leave-to {
    opacity: 0;

    .modal-body{
      transform: translateY(100px);
    }
  }
</style>